export const clientSideAdmin = {
  "fi" : {
    "prepaid_date": "Käyttö maksettu: {date}",
    "soft_closing_date": "Uusien käyttäjien lisääminen estetty: {date}",
    "license_free_until": "Veloitukseton käyttö voimassa: {date}",
    "closing_date": "Tili sulkeutuu: {date}",
    "invoicing_interval_months": "Laskutusväli",
    "student_amount": "Oppilasmäärä",
    "school_series": "Sarja",
    "parent_school_id": "Isäntäkoulun tunnus",
    "preferred_language": "Ensisijainen kieli",
    "allow_closed_reminders": "Salli sulkemismuistutukset",
    "allow_receipt_send": "Salli kuittausten lähetys",
    "is_closed": "Koulu on suljettu",
    "has_teacher_page": "Opettajan sivut käytössä",
    "student_codes_batch_amount": "Luotavien koodien määrä",
    "limits": "Harjoittelurajat",
    "clear_caches": "Tyhjennä välimuistit",
    "search_schools": "Hae kouluja",
    "menu_add_school": "Lisää koulu",
    "login_as_user": "Kirjaudu käyttäjänä",
    "menu_list_literals": "Listaa sanalliset",
    "menu_list_images": "Listaa kuvatehtävät",
    "menu_invoicing": "Laskutus",
    "edit": "Muokkaa",
    "add_comment": "Lisää kommentti",
    "sorting": "Järjestä",
    "assertion": "Väite",
    "language": "Kieli",
    "category": "Ajokorttiluokka",
    "show": "Näytä",
    "invoicing": "Laskujen luonti",
    "url": "Verkko-osoite",
    "none": "Ei mitään",
    "reports": "Raportit",
    "book_references": "Kirjan viittaukset",
    "assertions": "Väitteet",
    "descriptions": "Kuvaukset",
    "due_date": "Eräpäivä",
    "total": "Yhteensä",
    "total_inc_vat": "Yhteensä (ALV)",
    "payment_received_date": "Maksettu pvm",
    "invoices": "Laskut",
    "start_date": "Alkaen",
    "end_date": "Päättyen",
    "apply": "Käytä",
    "user_discount_percentage": "Alennus käyttäjistä (%)",
    "netvisor_id": "Netvisor ID",
    "netvisor_status": "Laskun tila",
    "export_invoice": "Vie Netvisoriin",
    "invoicing_threshold": "Laskun minimisumma (€)",
    "period_count": "Käyttäjiä (laskutettavia jaksoja)",
    "invoice_total": "Loppusumma",
    "create_invoices": "Luo laskut",
    "invoice_date": "Laskun päiväys",
    "menu_webshop_orders": "Verkkokauppaostokset",
    "order_info_page": "Tilauksen infosivu",
    "add_do": "Lisää",
    "webshop_orders": "Verkkokaupan tilaukset",
    "duration": "Kesto",
    "not_available": "N/A",
    "category_licenses":"Ajokorttiluokkien lisenssit",
    "material_licenses":"Materiaalien lisenssit",
    "subscription_period": "Tilausaika",
    "login_logs": "Kirjautumislokit",
    "status": "Tila",
    "remove_password": "Poista salasana",
    "remove": "Poista",
    "set": "Aseta",
    "modified": "Muokattu",
    "error_fetching_data": "Virhe tietojen haussa",
    "review_status": "Tarkistustila",
    "review_indicator": "Tarkistettava!",
    "missing_localization_indicator": "Tarvitsee käännöksiä",
    "change_order_status_to_ok": "Hyväksy tilaus",
    "search_type_userid": "Käyttäjätunnus",
    "search_type_email": "Sähköpostiosoite",
    "search_type_name": "Nimi",
    "search_exact": "Tarkka osuma",
    "search_type_phone": "Puhelin",
    "search_type_date": "Päivämäärä",
    "search_placeholder_name": "Hae nimellä",
    "search_placeholder_email": "Hae sähköpostilla",
    "search_placeholder_phone": "Hae puhelimitse",
    "create_literal": "Lisää uusi kysymys",
    "create_image": "Lisää uusi kuvakysymys",
    "literal_create_success": "Kysymys lisätty onnistuneesti",
    "literal_create_fail": "Kysymyksen luonti epäonnistui",
    "image_create_success": "Kuvakysymys lisätty onnistuneesti",
    "image_create_fail": "Kuvakysymyksen luonti epäonnistui",
    "validation_errors": "Validointivirheet",
    "validation_correct_answer_required": "Oikea vastaus on pakollinen",
    "validation_correct_answer_invalid": "Oikea vastaus voi olla vain A, B tai C",
    "validation_question_required": "Kysymys (FI) on pakollinen",
    "validation_option_a_required": "Vaihtoehto A (FI) on pakollinen",
    "validation_option_b_required": "Vaihtoehto B (FI) on pakollinen",
    "validation_option_c_required": "Vaihtoehto C (FI) on pakollinen",
    "validation_assertion_id_required": "Väitteen ID on pakollinen",
    "validation_image_id_required": "Kuvan ID on pakollinen",
  },
  en: {
    "prepaid_date": "Prepaid date: {date}",
    "soft_closing_date": "Prevent adding new users from: {date}",
    "license_free_until": "License valid until: {date}",
    "closing_date": "Closing date: {date}",
    "invoicing_interval_months": "Billing interval",
    "student_amount": "Student amount",
    "school_series": "Series",
    "parent_school_id": "Parent school id",
    "preferred_language": "Preferred language",
    "allow_closed_reminders": "Allow reminders about closed school",
    "allow_receipt_send": "Allow notifications for accepted students",
    "is_closed": "The school is closed",
    "has_teacher_page": "School has a teacher page",
    "student_codes_batch_amount": "Number of codes to be generated",
    "limits": "Training limits",
    "clear_caches": "Reload caches",
    "search_schools": "Search for schools",
    "menu_add_school": "Add a school",
    "login_as_user": "Log in as a user",
    "menu_list_literals": "List literals",
    "menu_list_images": "List images",
    "menu_invoicing": "Billing",
    "edit": "Edit",
    "add_comment": "Add a comment",
    "sorting": "Sort",
    "assertion": "Assertion",
    "language": "Language",
    "category": "Category",
    "show": "Show",
    "invoicing": "Invoicing",
    "url": "Web address",
    "none": "None",
    "reports": "Reports",
    "book_references": "Book references",
    "assertions": "Assertions",
    "descriptions": "Descriptions",
    "due_date": "Due date",
    "total": "Total",
    "total_inc_vat": "Total (VAT)",
    "payment_received_date": "Paid date",
    "invoices": "Invoices",
    "start_date": "Start date",
    "end_date": "End date",
    "apply": "Apply",
    "user_discount_percentage": "User discount (%)",
    "netvisor_id": "Netvisor ID",
    "netvisor_status": "Invoice status",
    "export_invoice": "Export to Netvisor",
    "invoicing_threshold": "Minimum invoice amount (€)",
    "period_count": "User amount (period count)",
    "invoice_total": "Invoice amount",
    "create_invoices": "Create invoices",
    "invoice_date": "Invoice date",
    "menu_webshop_orders": "Webshop orders",
    "order_info_page": "Order information",
    "add_do": "Add",
    "webshop_orders": "Webshop orders",
    "duration": "Duration",
    "not_available": "N/A",
    "category_licenses":"Category licenses",
    "material_licenses":"Material licenses",
    "subscription_period": "Subscription period",
    "login_logs": "Login logs",
    "status": "Status",
    "remove_password": "Remove password",
    "disconnect": "Disconnect",
    "set": "Set",
    "modified": "Modified",
    "error_fetching_data": "Error fetching data",
    "review_status": "Review status",
    "review_indicator": "Waiting for review!",
    "missing_localization_indicator": "Needs translations!",
    "change_order_status_to_ok": "Accept order",
    "search_type_userid": "User Id",
    "search_type_email": "Email",
    "search_type_name": "Name",
    "search_exact": "Exact match",
    "search_type_phone": "Phone",
    "search_type_date": "Date",
    "search_placeholder_name": "Search by name",
    "search_placeholder_email": "Search by email",
    "search_placeholder_phone": "Search by phone",
    "create_literal": "Add new question",
    "create_image": "Add new image question",
    "literal_create_success": "Question created successfully",
    "literal_create_fail": "Question creation failed",
    "image_create_success": "Image question created successfully",
    "image_create_fail": "Image question creation failed",
    "validation_errors": "Validation errors",
    "validation_correct_answer_required": "Correct answer is required",
    "validation_correct_answer_invalid": "Correct answer can only be A, B or C",
    "validation_question_required": "Question (FI) is required",
    "validation_option_a_required": "Option A (FI) is required",
    "validation_option_b_required": "Option B (FI) is required",
    "validation_option_c_required": "Option C (FI) is required",
    "validation_assertion_id_required": "Assertion ID is required",
    "validation_image_id_required": "Image ID is required",
  }
};